import styled from "styled-components";
import * as Colors from "../../styles/Colors";

export const Page = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  min-height: 100vh;
`;

export const Menu = styled.div`
  background-color: ${Colors.primary.black};
  width: 120px;
`;

export const Main = styled.div`
  background-color: white;
  flex-grow: 1;
  width: 100vw;
`;

export const SearchHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 15px;
  border-bottom: 5px solid ${Colors.primary.black};
`;

export const ErrorSnackBar = styled.div`
  visibility: hidden;
  min-width: 250px;
  margin-left: 0;
  background-color: #333;
  color: #fff;
  text-align: center;
  border-radius: 2px;
  padding: 16px;
  position: fixed;
  z-index: 1;
  left: 50%;
  bottom: 30px;
  font-size: 17px;
  visibility: visible;
  -webkit-animation: fadein 0.5s;
  animation: fadein 0.5s;

  @-webkit-keyframes fadein {
    from {
      bottom: 0;
      opacity: 0;
    }
    to {
      bottom: 30px;
      opacity: 1;
    }
  }

  @keyframes fadein {
    from {
      bottom: 0;
      opacity: 0;
    }
    to {
      bottom: 30px;
      opacity: 1;
    }
  }
`;
